import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { networkErrorHandler } from '../utils/NetworkErrorHandler';
import { getAccessToken } from '../utils/authUtils';
import isInCCLiframe from '../utils/isInCCLiframe';
import { FEATURE_TOGGLE } from '../utils/FeatureToggle';

export const ORGANISATION_SERVICE_ENDPOINT = '/graphql';
export const AUTHORING_AGGREGATOR_ENDPOINT = '/authoring-graphql';
export const TENANT_GATEWAY_ENDPOINT = '/graphql-gateway';
export const MARKETPLACE_GATEWAY = '/marketplace-graphql';

const getParam = (name: string) =>
  new URLSearchParams((window as any).location.search).get(name);

export function getApolloClient(
  uri: string,
  addTypename = true,
  token: string | null = '',
) {
  const cache = new InMemoryCache({
    addTypename,
  });

  const iframeHeaders = () => ({
    'x-tenantid': getParam('organisation'),
  });

  const headers = isInCCLiframe ? iframeHeaders() : {};

  const captureHeadersLink = new ApolloLink((operation, forward) => {
    return forward(operation).map((response) => {
      const {
        response: { headers },
      } = operation.getContext();
      const totalCount = headers.get('x-total-count');

      if (totalCount) {
        localStorage.setItem('totalCount', totalCount);
      }
      return response;
    });
  });

  const httpLink = new HttpLink({
    uri,
    headers: {
      authorization: `Bearer ${getParam('token') || token || getAccessToken()}`,
      ...headers,
    },
  });
  const logoutLink = onError(({ networkError }) => {
    networkErrorHandler(networkError);
  });

  return new ApolloClient({
    link: ApolloLink.from([logoutLink, captureHeadersLink, httpLink]),
    credentials: 'same-origin',
    cache,
  });
}

export const createDynamicApolloClient = (tenant: string) => {
  return getApolloClient(
    `https://${tenant}${FEATURE_TOGGLE.CONTENT_DOMAIN}${TENANT_GATEWAY_ENDPOINT}`,
    true,
    getParam('token'),
  );
};

export default getApolloClient;
